import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import AdminLogin from './pages/admin-login';
import NewsletterArchive from './pages/newsletter-archive';
import HomePage from './pages/home-page';
import NewsletterAdminEditor from './pages/newsletter-admin-editor';
import NewsletterDetailPage from './pages/newsletter-detail-page';
import CreateNewsletterPage from './pages/create-newsletter-page';
import ResetPasswordPage from './pages/reset-password-page';

const ProjectRoutes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home-page" element={<Navigate to="/" replace />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin-dashboard/create-newsletter" element={<CreateNewsletterPage />} />
            <Route path="/newsletter-admin-editor" element={<NewsletterAdminEditor />} />
            <Route path="/newsletter-admin-editor/:id" element={<NewsletterAdminEditor />} />
            <Route path="/newsletter-archive" element={<NewsletterArchive />} />
            <Route path="/newsletter/:slug" element={<NewsletterDetailPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default ProjectRoutes;